import { createSortOption } from "@nosto/preact"
export const sizes = [44, 88, 132, 186]

export const sortOptions = [
    createSortOption("score", "Best Match", { field: "score", order: "desc" }),
    createSortOption("newest", "Newest", { field: "datePublished", order: "desc" }),
    // createSortOption("name", "Name: A-Z", { field: "name", order: "asc" }),
    // createSortOption("-name", "Name: Z-A", { field: "name", order: "desc" }),
    createSortOption("price", "Price: Low to High", { field: "price", order: "asc" }),
    createSortOption("-price", "Price: High to Low", { field: "price", order: "desc" }),
    // createSortOption("oldest", "Oldest First", { field: "datePublished", order: "desc" }),
    // createSortOption("rating", "Top Rated: Lowest - Highest", { field: "ratingValue", order: "asc" }),
    // createSortOption("-rating", "Top Rated: Highest - Lowest", { field: "ratingValue", order: "desc" }),
]

export const defaultConfig = {
    sort: sortOptions[0],
    serpSize: sizes[0],
    autocompleteProductsSize: 4,
    autocompleteKeywordsSize: 4,
    historySize: 4,
}

export const facetValueOrder = {
    "Frame Size": [' 2\" x 3\"', ' Under 3\" x 3\"', ' Under 4\" x 6\"', ' 4\" x 6\"', ' Under 5\" x 7\"'],
    "Ring Size": ['5','6','7','8','9','10','OS'],
    "Shoe Size": ['5', '5.5','6','6.5','7','7.5','8','8.5','9','9.5','10','10.5','11']
}

export const topSearches = [
    { text: 'Bracelets', url: '/collections/bracelets' },
    { text: 'Earrings', url: '/collections/earrings' },
    { text: 'Necklaces', url: '/collections/necklaces' },
    { text: 'Charms', url: '/collections/dangle-charms' },
    { text: 'Gold', url: '' },
]

export const categoryVisuals = [
    { id: "407296344296", name: "Earring Type" }, // Earrings
    { id: "407295951080", name: "Bracelet Type" }, // Bracelets
    { id: "408806719720", name: "Charm Type" } //Charms
]

export const filterImages = {
    "Earring Type": {
        "Drop": "https://cdn.shopify.com/s/files/1/0635/0526/8968/files/mfield_cql_earring_type__drop.png?v=1666022090",
        "Stud": "https://cdn.shopify.com/s/files/1/0635/0526/8968/files/mfield_cql_earring_type__stud.png?v=1666022089",
        "Hoop": "https://cdn.shopify.com/s/files/1/0635/0526/8968/files/mfield_cql_earring_type__hoop.png?v=1666022090",
    },
    "Bracelet Type": {
        "Chain": "https://cdn.shopify.com/s/files/1/0635/0526/8968/files/mfield_cql_bracelet_type__chain.png?v=1666022089",
        "Bangle": "https://cdn.shopify.com/s/files/1/0635/0526/8968/files/mfield_cql_bracelet_type__bangle.png?v=1666022089",
        "Cuff": "https://cdn.shopify.com/s/files/1/0635/0526/8968/files/mfield_cql_bracelet_type__cuff.png?v=1666022089",
        "Stretch": "https://cdn.shopify.com/s/files/1/0635/0526/8968/files/mfield_cql_bracelet_type__stretch.png?v=1666022089",
        "Leather": "https://cdn.shopify.com/s/files/1/0635/0526/8968/files/mfield_cql_bracelet_type__leather.png?v=1666022089",
        "Charm Bracelet": "https://cdn.shopify.com/s/files/1/0635/0526/8968/files/mfield_cql_bracelet_type__charm-bracelet.png?v=1666302499",
    },
    "Charm Type": {
        "Seasonal": "https://cdn.shopify.com/s/files/1/0635/0526/8968/files/mfield_cql_charm_theme__seasonal_f21f34cf-d90d-455a-b99a-1b09a05d2de0.png?v=1766432538",
        "Love": "https://cdn.shopify.com/s/files/1/0635/0526/8968/files/mfield_cql_charm_theme__love_9458bdee-28ce-486f-b18f-f54d5cd2a6a0.png?v=1733272674",
        "Family and Faith": "https://cdn.shopify.com/s/files/1/0635/0526/8968/files/mfield_cql_charm_theme__family-and-faith_e0396767-fe7b-4eaf-9939-bee7c61a389c.png?v=1742245689",
        "Celebrations": "https://cdn.shopify.com/s/files/1/0635/0526/8968/files/mfield_cql_charm_theme__celebrations_bbfff3f1-9c08-48ce-95a8-970ab869e2ce.png?v=1733272675",
        "Passions and Pastimes": "https://cdn.shopify.com/s/files/1/0635/0526/8968/files/mfield_cql_charm_theme__passions-and-pastimes_542c164b-94d0-4ccd-a230-0761c6d9333d.png?v=1733272675",
        "Animals and Nature": "https://cdn.shopify.com/s/files/1/0635/0526/8968/files/mfield_cql_charm_theme__animals-and-nature_9a923b9e-20d1-4b63-a2c9-afac579c3b20.png?v=1733272674",
        "Travel and Hobbies": "https://cdn.shopify.com/s/files/1/0635/0526/8968/files/mfield_cql_charm_theme__travel-and-hobbies_b6fc8591-03a2-4327-aa26-c948945e6b96.png?v=1733272675",
        "Silver, Gold, and Sparkle": "",
        "Letters and Numbers": "",
    }
}

export const visualFilterFlktyOptions = { 
    watchCSS: false, 
    cellAlign: 'left', 
    contain: true, 
    pageDots: true, 
    wrapAround: true, 
    adaptiveHeight: false, 
    groupCells: true,
    accessability: true,
    prevNextButtons: true, 
    arrowShape: 'M 10,50 L 60,100 L 65,100 L 15,50  L 65,0 L 60,0 Z'
}

export const searchRefColors = [
    'black', 
    'blue', 
    'brown', 
    'gold', 
    'gray', 
    'green', 
    'metallic', 
    'multi', 
    'none', 
    'orange', 
    'pink', 
    'purple', 
    'red', 
    'silver', 
    'tan',
    'white', 
    'yellow'
];

/* OTHER CONSTANTS */
export const SKELETON_LOADER_PRODUCT_CARDS = 44;

export const INITIAL_SWATCHES_SHOWN = 3;
export const SKU_CUSTOMFIELD_SIMPLE_COLOR = 'cql-generic_color';

export const SEARCH_DROPDOWN_REC_ID = 'searchdropdown-nosto-1';
export const NO_RESULTS_REC_IDS = ['notfound-nosto-1', 'notfound-nosto-2', 'notfound-nosto-3'];

export const LOCAL_STORAGE_SCROLL = 'nosto_search_category_scroll'